// Auth route — "Reset password from link" (US-006).

import { createRoute } from '@tanstack/react-router';

import { ResetPasswordPage } from '@/features/auth/ResetPasswordPage';

import { Route as RootRoute } from '../__root';

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/auth/reset',
  validateSearch: (search): { token?: string } => ({
    token: typeof search.token === 'string' ? search.token : undefined,
  }),
  component: ResetPasswordPage,
});
